module.exports = __webpack_public_path__ + "static/media/Icon 4.ee3c278b.png";